<template>
    <div :resource="resource">
        <iframe :src="resource.storage_path" frameborder="0" class="ts-w-full ts-h-full" style="height: 70vh;"></iframe>
    </div>
</template>

<script>
export default {
    name: 'pdfView',
    props: {
        resource: {
            type: Object,
            required: true
        }
    }
}
</script>
